// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import Users from "@insite/mobius/Icons/Users";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { wishListSharingStatusStyles } from "@synd/Overrides/Components/WishListSharingStatus";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    mergeCss: true,
    extendedStyles: {
        triggerWrapper: {
            css: css`
                margin-left: 0;
            `,
        },
    },
    iconProps: {
        mergeCss: true,
        src: HelpCircle,
        css: css`
            margin-right: 6px;
        `,
    },
};

wishListSharingStatusStyles.statusText = {
    size: fontConfig.xSmall.size,
    lineHeight: fontConfig.xSmall.lineHeight,
    css: css`
        display: flex;
        align-items: center;
        &,
        &&&& {
            ${IconWrapper} {
                position: relative;
                padding-top: 3px;
            }
            & > ${TypographyStyle} {
                font-size: ${fontConfig.xSmall.size}px;
                line-height: ${fontConfig.xSmall.lineHeight};
                font-weight: ${fontConfig.weight.regular};
                display: flex;
                align-items: center;
            }
        }
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 13,
    ...{ width: 11, height: 13 },
    css: css`
        margin-right: 5px;
        margin-bottom: 3px;
        svg {
            color: ${color("common.ui6")};
        }
        &:hover {
            svg {
                color: ${color("text.link")};
            }
        }
    `,
};

wishListSharingStatusStyles.autogeneratedTooltip = {
    mergeCss: true,
    iconProps: {
        size: 12,
        css: css`
            margin-left: 6px;
            top: 2px;
            &,
            & svg {
                height: 12px;
            }
        `,
    },
};
